export default __webpack_public_path__ + "static/media/ic-arrow-back-white.a6c81a9b.svg";